import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "dayjs/locale/pt"; // Importa o locale português
import dayjs from "dayjs";
import { ptBR } from "@mui/x-date-pickers/locales";
dayjs.locale("pt"); // Define o locale globalmente
import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

import "react-toastify/dist/ReactToastify.css";

import { AllocationProvider } from "./externalComponent/hooks/useAllocations.tsx";

const keycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
};

const theme = createTheme({
  palette: {
    primary: {
      main: "#781AA0",
    },
    secondary: {
      main: "#212121",
    },
  },
});

const initOptions = { onLoad: "login-required" };

createRoot(document.getElementById("root")!).render(
  <ReactKeycloakProvider
    authClient={new Keycloak(keycloakConfig)}
    initOptions={initOptions}
  >
    <ThemeProvider theme={theme}>
      <AllocationProvider>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="pt-br"
          localeText={
            ptBR.components.MuiLocalizationProvider.defaultProps.localeText
          }
        >
          <ToastContainer />
          <App />
        </LocalizationProvider>
      </AllocationProvider>
    </ThemeProvider>
  </ReactKeycloakProvider>
);
